module.exports = __webpack_public_path__ + "img/moobel.7d93bc5d.svg";